import { pipe } from 'rxjs'
import { Citation } from '../types/redux-citation-api'
import Clipboard from './clipboardPolyfill'
import { map, filter } from './functions'
import {
  keepTextContent as stripCitationHTML,
  sanitizeHtmlWithFilter as sanitizeCitationHTML,
  htmlDecode,
} from './contentFilters'

const pickCitationHTMLContents = (
  citations: Citation[]
): Citation['formatted_data']['output'][] =>
  pipe(
    map((citation) => citation.formatted_data.output),
    filter((x) => !!x)
  )(citations)

export const citationsPlainText = (unsanitizedCitations: Citation[]): string =>
  pipe(
    pickCitationHTMLContents,
    map(stripCitationHTML),
    map(htmlDecode)
  )(unsanitizedCitations).join('\n')

/**
 * Make a piece of HTML text content look like it's indented
 * @param html A string of valid HTML code
 */
const indentHTMLContent = (html: string): string =>
  `<p style="margin-left: 1cm; text-indent: -1cm;">${html}</p>`

export const citationsHtml = (unsanitizedCitations: Citation[]): string =>
  pipe(
    pickCitationHTMLContents,
    map(sanitizeCitationHTML),
    map(indentHTMLContent)
  )(unsanitizedCitations).join('')

export const copyAll = (citations: Citation[]) => {
  const formattedCitations = {
    'text/plain': citationsPlainText(citations),
    'text/html': citationsHtml(citations),
  }
  Clipboard.copy(formattedCitations)
}
